import { Typography } from "antd"

import css from "./index.module.css"

type Props = {
  amount: number | string
  children?: React.ReactNode
  currency?: string
  icon: string
  title: string
}

const { Title } = Typography

export const AffiliateBlock = ({
  amount,
  children,
  currency,
  icon,
  title,
}: Props) => {
  return (
    <div className={css.container}>
      <Title className={css.title} level={5}>
        {title}
      </Title>
      <div className={css.wrapper}>
        <img alt="icon" className={css.icon} src={icon} />
        <span className={css.amount}>{amount}</span>
        <span className={css.currency}>{currency}</span>
      </div>
      {children}
    </div>
  )
}
